import React from "react";
import {
  CircularProgressbar,
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
const DropoutMatrix = props => {
  const {t} = useTranslation();
  const {
    screeningTestNotAttempted,
    interviewNotAttended,
    offerRejectedByCandidates,
  } = props?.data || {};

  const rowStyle = {
    display: "flex",
    flexDirection: "column",
    marginBottom: "1rem",
  };

  const labelStyle = {
    fontWeight: "500",
    marginBottom: "0.5rem",
    width: "100%",
  };

  const progressBarContainerStyle = {
    backgroundColor: "lightgray",
    height: "25px",
    borderRadius: "12px",
    overflow: "hidden",
  };

  const progressBarStyle = (width, color) => ({
    width: `${width}%`,
    backgroundColor: color,
    height: "100%",
    textAlign: "center",
    lineHeight: "25px",
    color: "white",
    borderRadius: "12px",
  });
  return (
    <div className="col-12">
      <div className="dropout-matrix">
        <div className="col-lg-12">
          <div className="eligible-content mt-1">
            <h5 className="heading-one">
              {/* Dropout Matrix */} {t(`Dashboard.Dropout Analysis`)}
            </h5>
          </div>
        </div>

        <div className="dropout-matrix-line">
          <div className="card-table-details tonality tabel-application table-responsive ">
            <div className="progress-chart-table Transcript" key="emo">
              <div className="progress-children-chart">
                <CircularProgressbarWithChildren
                  value={screeningTestNotAttempted}
                  styles={buildStyles({
                    pathColor: "#4AC18E",
                    trailColor: "#eee",
                    strokeLinecap: "butt",
                  })}
                >
                  <div style={{ fontSize: 14, marginTop: -5 }}>
                    <strong>
                      {Math.round(screeningTestNotAttempted || 0) + " %"}
                    </strong>{" "}
                  </div>
                </CircularProgressbarWithChildren>
                <h5> {t(`Dashboard.Screening Not Attempted`)}</h5>
              </div>

              <div className="progress-children-chart">
                <CircularProgressbarWithChildren
                  value={interviewNotAttended}
                  styles={buildStyles({
                    pathColor: "#F46A6A",
                    trailColor: "#eee",
                    strokeLinecap: "butt",
                  })}
                >
                  <div style={{ fontSize: 14, marginTop: -5 }}>
                    <strong>
                      {Math.round(interviewNotAttended || 0)} %
                    </strong>{" "}
                  </div>
                </CircularProgressbarWithChildren>
                <h5>{t(`Dashboard.Interview Not Attended`)}</h5>
              </div>

              <div className="progress-children-chart">
                <CircularProgressbarWithChildren
                  value={offerRejectedByCandidates}
                  styles={buildStyles({
                    pathColor: "#FFBB44",
                    trailColor: "#eee",
                    strokeLinecap: "butt",
                  })}
                >
                  <div style={{ fontSize: 14, marginTop: -5 }}>
                    <strong>
                      {Math.round(offerRejectedByCandidates || 0)} %
                    </strong>{" "}
                  </div>
                </CircularProgressbarWithChildren>
                <h5>{t(`Dashboard.Offer Rejected`)}</h5>
              </div>
            </div>
          </div>
          {/* <div className="w-100">
            <div style={labelStyle}>Screening Test Not Attempted</div>
            <div style={progressBarContainerStyle} className="progressheight">
              <div
                className="progress-bar"
                role="progressbar"
                style={progressBarStyle(screeningTestNotAttempted, "green")}
                aria-valuenow={screeningTestNotAttempted}
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {screeningTestNotAttempted}%
              </div>
            </div>
          </div>

          <div className="w-100">
            <div style={labelStyle}>Interview Not Attended</div>
            <div style={progressBarContainerStyle} className="progressheight">
              <div
                className="progress-bar"
                role="progressbar"
                style={progressBarStyle(interviewNotAttended, "red")}
                aria-valuenow={interviewNotAttended}
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {interviewNotAttended}%
              </div>
            </div>
          </div>

          <div className="w-100">
            <div style={labelStyle}>Offer Rejected by Candidates</div>
            <div style={progressBarContainerStyle} className="progressheight">
              <div
                className="progress-bar"
                role="progressbar"
                style={progressBarStyle(offerRejectedByCandidates, "orange")}
                aria-valuenow={offerRejectedByCandidates}
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {offerRejectedByCandidates}%
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default DropoutMatrix;
